import { Button } from '@sunstone/ui';
import { useNavigate } from 'react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { useAuthorization } from '@/features/auth/useAuthorization';
import { TenantList } from '@/features/tenants/TenantList';

export function PartnersPage() {
  const navigate = useNavigate();
  const { hasPermission } = useAuthorization();

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <PageHeader
        title="Partners"
        description="Manage partner organizations and their customers."
        action={
          hasPermission('create:partner') && (
            <Button onClick={() => navigate('/partners/new')}>New Partner</Button>
          )
        }
      />
      <TenantList mode="partners" urlParams />
    </div>
  );
}
